import { render, staticRenderFns } from "./input-description.vue?vue&type=template&id=6d7af310&"
import script from "./input-description.vue?vue&type=script&lang=js&"
export * from "./input-description.vue?vue&type=script&lang=js&"
import style0 from "./input-description.vue?vue&type=style&index=0&id=6d7af310&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports